'use strict';
(function () {
    var subscribeSection = $('.subscribe');

    $(window).scroll(function(){
        var windowOffset =  $(document).scrollTop();
        var cookie_block = $('.cookie_blog');
        if(windowOffset <= 200){
            subscribeSection.css('visibility', 'hidden');
        } else {
            subscribeSection.css('visibility', 'visible');
            if(!cookie_block.hasClass('hidden')){
                subscribeSection.css('bottom', cookie_block.outerHeight() + 'px');
            }
            else {
                subscribeSection.css('bottom', '0');
            }
        }
    });
})();